import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";

const FetchSubSystems = (props) => {
  const queryParams = new URLSearchParams(window.location.search);
  const accessToken = queryParams.get("userAuthToken");
  const [systemId, setSystemId] = useState('');

  const [preSelected, setPreselected] = useState('')
  useEffect(() => {
    setSystemId(props.serviceComponentId);
    setPreselected(props.value)
  }, [props.value, props.serviceComponentId])

  const loadOptions = async (searchQuery, _, { page }) => {

    const response = await fetch(
      `/api/v1/service_codes/aar/sub_systems?service_component=${systemId ? systemId : ''}&search=${searchQuery}&page=${page}`, {
      method: 'GET',
      headers: {
        'Access-Token': accessToken,
      },
    }
    );
    const responseJSON = await response.json();

    let options = responseJSON.sub_service_components.map((option) => ({
      label: `${option.name}`,
      value: `${option.id}`,
      data: option
    }))

    return {
      options: options,
      hasMore: responseJSON.meta.has_more,
      additional: {
        page: page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: '#5195FB',
      minHeight: '30px',
      height: '30px',
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: '30px',
      padding: '0 6px'
    }),

    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '30px',
    }),
  };

  return (
    <>
      {typeof (props.value) === 'string' ?
        <AsyncPaginate
          key={JSON.stringify(systemId)}
          defaultValue={{ value: props.value, label: props.value }}
          loadOptions={loadOptions}
          onChange={onChange}
          isSearchable={true}
          placeholder="Sub system"
          className='service_dropdown'
          styles={customStyles}
          debounceTimeout={500}
          additional={{
            page: 1,
          }}
        /> :
        <AsyncPaginate
          key={JSON.stringify(systemId)}
          value={props.value === null ? props.currentServiceList : props.value}
          loadOptions={loadOptions}
          onChange={onChange}
          isSearchable={true}
          placeholder="Sub system"
          className='service_dropdown'
          styles={customStyles}
          debounceTimeout={500}
          additional={{
            page: 1,
          }}
        />
      }
    </>
  );
};

FetchSubSystems.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  serviceComponentId: PropTypes.string
};

export default FetchSubSystems;
